import { useCallback } from 'react';
import { skipToken } from '@reduxjs/toolkit/query';
import { useAppDispatch } from '@/store';
import {
	setSeenArticleIds,
	useSeenNewsfeedArticleIdsSelector,
} from '../store/slices/newsfeed.slice';
import { useGetNewsfeedQuery } from '../store/api/newsfeed.api';

export function useNewsfeedDigest(eventId?: string) {
	const dispatch = useAppDispatch();
	const { data, isLoading } = useGetNewsfeedQuery(eventId ? { event_id: eventId } : skipToken);
	const articles = data?.articles ?? [];
	const title = data?.title;
	const seenIds = useSeenNewsfeedArticleIdsSelector(eventId);
	const hasArticles = articles.length > 0;
	const isUnread = articles.some((article) => !seenIds.includes(article.id));

	const markSeen = useCallback(() => {
		if (!eventId || !articles.length) return;
		dispatch(setSeenArticleIds({ eventId, articleIds: articles.map((article) => article.id) }));
	}, [dispatch, eventId, articles]);

	return { articles, hasArticles, isUnread, markSeen, title, isLoading };
}
